import React from 'react';
import { Tooltip, TooltipProps } from '@mui/material';
import styled, { css } from 'styled-components';
import { rem } from '../../utils/styles';
import { StylovyzeTooltipProps } from './StylovyzeTooltip';

export const Wrapper = styled.div``;

type StyledTooltipProps = TooltipProps &
	Omit<StylovyzeTooltipProps, 'heading' | 'title' | 'content'>;

const MyTooltip = (props: StyledTooltipProps) => (
	<Tooltip
		classes={{
			popper: props.className,
			tooltip: 'tooltip',
			arrow: 'arrow',
		}}
		{...props}
	/>
);

export const LightTooltip = styled(MyTooltip)`
	& .tooltip {
		font-size: ${rem(12)};
		background-color: ${({ theme }) =>
			theme?.palette?.common?.white || '#fff'};
		color: ${({ theme }) => theme?.palette?.text?.primary || '#252f33'};
		border-radius: ${({ theme }) => theme?.shape?.borderRadius || 4}px;
		padding: ${({ padded }) => padded && rem(20)};
		margin: ${({ removeExternalSpacing }) => removeExternalSpacing && 0};
		box-shadow: ${({ theme }) =>
			theme?.shadows?.[3] ||
			'0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)'};
		max-width: ${rem(300)};
	}
	& .arrow {
		color: ${({ theme }) => theme?.palette?.common?.white || '#fff'};
		&:before {
			box-shadow: ${({ theme }) =>
				theme?.shadows?.[3] ||
				'0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)'};
		}
	}

	& .tooltip {
		${({ removeExternalSpacing }) =>
			removeExternalSpacing &&
			css`
				padding: ${rem(20)};
			`}
	}
`;

export const Heading = styled.div`
	color: ${({ theme }) => theme?.palette?.text?.primary || '#252f33'};
	font-weight: ${({ theme }) => theme?.typography?.fontWeightMedium || 500};
	margin-bottom: ${rem(5)};
	line-height: ${({ theme }) => theme?.typography?.body2?.lineHeight || 1.43};
`;

export const Content = styled.div`
	color: ${({ theme }) =>
		theme?.palette?.text?.secondary || 'rgba(0, 0, 0, 0.6)'};
	font-size: ${({ theme }) =>
		theme?.typography?.body2?.fontSize || '0.875rem'};
	line-height: ${({ theme }) => theme?.typography?.body2?.lineHeight || 1.43};
`;
